import { useState } from "react"
import { googleAuth } from "@/lib/http/auth"
import { useToast } from "@/hooks/useToast"

export function useGoogleAuth() {
  const [isLoading, setIsLoading] = useState(false)
  const { toast } = useToast()

  const handleGoogleAuth = async () => {
    try {
      setIsLoading(true)
      const { url } = await googleAuth()

      if (url) {
        // Redirect to Google OAuth
        window.location.href = url
      } else {
        toast({
          title: "Authentication Error",
          description: "Cannot access Google. Please try again later.",
          variant: "destructive",
        })
      }
    } catch (error) {
      console.error("Google auth error:", error)
      toast({
        title: "Authentication Error",
        description: "Google login is currently unavailable. Please try again later.",
        variant: "destructive",
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    handleGoogleAuth,
    isLoading,
  }
}
